
import { Placement } from '@post-office/placements-frontend/audio-player-spotlight-tour';
export default Placement;
